/* @ngInject */
export default function tokenParamInterceptor(oauthConfig, tokenService) {
  return {
    request: function (reqConfig) {
      const token     = tokenService.getToken();
      const isApiCall = reqConfig.url.indexOf(oauthConfig.api) !== -1;
      if (isApiCall && token && !reqConfig.ignoreTokenInterceptor) {
        const urlHasParams = reqConfig.url.indexOf("?") !== -1;
        const prefix       = urlHasParams ? "&" : "?";
        reqConfig.url += `${prefix}access_token=${token}`
      }
      return reqConfig;
    }
  }
}


// WEBPACK FOOTER //
// ./src/interceptors/tokenParam.interceptor.js